import React from 'react'
import "./Home.css";
import { Link } from 'react-router-dom';
const Home = () => {
    const image=require("../images/download.jpg");
  return (
    <div className="Home-Page bg-dark text-white container-fluid d-flex justify-content-center  align-items-center flex-column">
        <div className="row container ">
            <div className="col-lg-6 d-flex justify-content-center  align-items-start flex-column" style={{ height: "91.5vh" }}
            >
            <h2 style={{fontSize: "90px"}}>Book Store</h2>
            <h2 style={{fontSize: "50px",color:"#1992e2"}}>For You</h2>
            <p className="mb-0" style={{fontWeight:"bold",color:"gray"}}>Checkout The Books From Here.</p>
            <Link to="/books" className='viewBook my-3' >View Books
            </Link>
            </div>
            <div
             className="col-lg-6 d-flex justify-content-center align-items-center flex-column"
             style={{height:"91.5vh"}}
             >
                <img className="imag-fluid homimg" src={image} alt="" />
             </div>
        </div>
    </div>
  );
};

export default Home;